import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" >
<path d="M1989 6513 c-32 -31 -59 -62 -59 -70 0 -7 27 -48 61 -90 82 -103 118
-161 194 -313 73 -145 84 -172 126 -315 84 -283 93 -606 25 -927 -49 -231
-192 -537 -348 -741 -42 -55 -57 -83 -53 -97 8 -24 112 -120 130 -120 18 0 69
61 158 189 197 283 321 620 358 971 14 135 6 435 -15 555 -19 113 -71 301
-107 393 -66 167 -183 375 -268 478 -14 18 -33 41 -41 52 -32 43 -81 92 -91
92 -6 0 -37 -25 -70 -57z"/>
<path d="M1492 6158 c-57 -52 -71 -69 -72 -86 0 -7 22 -40 48 -75 87 -111 164
-264 211 -422 114 -374 29 -843 -210 -1160 -21 -28 -39 -59 -39 -67 0 -24 105
-118 133 -118 18 0 36 16 72 65 154 211 251 441 290 690 23 145 16 409 -13
535 -41 173 -101 321 -190 469 -58 97 -149 211 -168 211 -8 0 -36 -19 -62 -42z"/>
<path d="M979 5793 c-76 -71 -76 -71 -20 -157 182 -280 181 -607 -3 -861 -20
-27 -36 -55 -36 -61 0 -16 116 -124 132 -124 31 0 111 110 163 224 98 210 112
464 39 685 -42 125 -174 341 -209 341 -9 0 -39 -21 -66 -47z"/>
<path d="M6518 5655 c-1 -27 -2 -128 -3 -223 -1 -95 -5 -175 -9 -179 -4 -4
-15 -2 -24 5 -85 61 -224 79 -332 42 -118 -40 -204 -127 -253 -258 -32 -84
-30 -253 3 -337 63 -163 177 -252 337 -263 90 -6 146 9 224 60 33 21 62 38 64
38 3 0 5 -11 5 -24 0 -51 8 -56 81 -56 48 0 69 4 69 13 0 6 0 286 0 622 l0
610 -80 0 -80 0 -2 -50z m-86 -508 c91 -53 90 -50 86 -258 -3 -176 -4 -185
-27 -216 -39 -53 -113 -86 -190 -86 -81 0 -129 22 -188 86 -56 60 -78 134 -70
234 10 129 72 218 180 260 52 20 158 10 209 -20z"/>
<path d="M8980 5080 l0 -620 85 0 85 0 0 620 0 620 -85 0 -85 0 0 -620z"/>
<path d="M6962 5664 c-49 -34 -66 -111 -34 -150 48 -59 108 -67 165 -21 22 17
30 34 34 70 5 44 3 49 -31 82 -42 39 -94 47 -134 19z"/>
<path d="M3149 5635 c-73 -54 -78 -75 -34 -145 36 -58 74 -170 86 -255 21
-149 -5 -298 -77 -441 -48 -95 -47 -103 7 -148 51 -43 78 -33 123 48 86 155
121 305 113 486 -6 145 -34 249 -97 365 -33 59 -73 115 -83 115 -2 0 -19 -11
-38 -25z"/>
<path d="M4633 5644 c-4 -10 -72 -129 -151 -264 -80 -135 -157 -266 -171 -292
-14 -26 -32 -48 -39 -48 -13 0 -61 73 -164 250 -33 58 -95 162 -136 233 l-76
127 -83 0 -83 0 0 -595 0 -595 85 0 c81 0 85 1 91 24 3 14 4 200 1 415 -3 229
-2 391 4 391 10 0 19 -14 149 -225 178 -290 167 -275 214 -275 l41 0 70 120
c39 67 93 155 121 198 28 42 63 101 79 130 54 100 55 93 55 -363 l0 -415 85 0
85 0 0 595 0 595 -54 0 c-29 0 -67 3 -85 6 -24 5 -32 3 -38 -12z"/>
<path d="M7312 5653 l-53 -4 3 -69 3 -70 175 -3 175 -3 3 -522 2 -522 90 0 90
0 2 523 3 522 175 0 175 0 3 78 3 77 -398 -2 c-219 -1 -422 -3 -451 -5z"/>
<path d="M5270 5310 c-55 -10 -144 -43 -187 -70 l-32 -19 32 -57 c18 -31 34
-57 37 -56 3 0 37 16 75 34 63 29 79 33 157 33 72 0 91 -4 114 -21 50 -37 68
-70 69 -127 l0 -52 -140 -7 c-269 -12 -381 -84 -393 -250 -6 -89 11 -150 57
-197 51 -52 103 -73 194 -79 95 -6 149 8 228 60 33 21 63 38 68 38 4 0 12 -17
17 -37 l9 -38 72 -3 73 -3 -6 58 c-3 32 -9 182 -13 333 -8 304 -11 319 -77
386 -64 63 -228 98 -354 74z m270 -529 c0 -77 -1 -79 -40 -124 -69 -78 -170
-108 -262 -78 -77 26 -106 146 -51 212 41 49 83 62 218 68 66 4 123 5 128 3 4
-2 7 -38 7 -81z"/>
<path d="M8305 5307 c-71 -24 -123 -56 -174 -108 -162 -164 -161 -492 1 -645
23 -22 59 -50 78 -62 85 -50 248 -67 351 -36 90 27 210 96 209 121 -1 4 -19
28 -40 53 -35 39 -42 43 -57 32 -10 -7 -47 -27 -83 -44 -112 -55 -227 -50
-312 15 -50 38 -97 118 -98 165 l0 32 310 0 310 0 0 58 c-1 178 -87 330 -227
398 -46 23 -73 29 -142 31 -52 2 -102 -2 -126 -10z m219 -155 c22 -15 48 -39
59 -54 22 -29 47 -116 40 -135 -8 -19 -432 -18 -439 0 -9 24 37 127 72 162 68
68 191 81 268 27z"/>
<path d="M6937 5293 c-4 -3 -7 -192 -7 -420 l0 -413 85 0 85 0 0 420 0 420
-78 0 c-43 0 -82 -3 -85 -7z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
